import React from 'react';
import { useTranslation } from 'react-i18next';

import AccessScopeEditor from '../../../components/ui/AccessScopeEditor';

export default function GateScopeTab({ gateId }) {
  const { t } = useTranslation();
  return (
    <AccessScopeEditor
      scopeUrl={`/v1/gates/${gateId}/scope`}
      includeAllHint={t('gate.scopeIncludeAllHint')}
    />
  );
}
